import { render, staticRenderFns } from "./DialogBulkUpdateCustomerForm.vue?vue&type=template&id=5a032ee0&"
import script from "./DialogBulkUpdateCustomerForm.vue?vue&type=script&lang=js&"
export * from "./DialogBulkUpdateCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports